import { Directive, ElementRef, Input, OnChanges, Renderer2 } from '@angular/core';
import { IMenuItem, MenuItemModel } from '../models/nav-item.model';

const INACTIVE_COLOR = 'var(--surface-500)';
const ACTIVE_COLOR = 'var(--primary-color)';

@Directive({
  selector: '[lhStarIconStyles]',
  standalone: true,
})
export class StarIconStylesDirective implements OnChanges {
  @Input() menuItem!: IMenuItem;
  @Input() favouriteSubmenu: MenuItemModel | null = null;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
  ) {}

  ngOnChanges(): void {
    const isFavourite = this.favouriteSubmenu?.items?.some((item) => item.routerLink === this.menuItem.routerLink);

    const color = isFavourite ? ACTIVE_COLOR : INACTIVE_COLOR;
    const display = isFavourite ? 'block' : '';

    this.renderer.setStyle(this.el.nativeElement, 'color', color);
    this.renderer.setStyle(this.el.nativeElement, 'display', display);
  }
}
